module.exports = __webpack_public_path__ + "img/insta-4.1f12c64d.jpg";